import RegistrationRequiredDocument from "../../domain/Registration/RegistrationRequiredDocument";
import S3DocumentMetaDataWithUrl from "../../domain/Registration/S3DocumentMetaDataWithUrl";
import UserSessionService from "../UserSessionService";
import WsService from "../WsService";

const ENDPOINT_BASE = "/registrations/documents";

export default class RegistrationDocumentService {

    static retrieveRegistrationRequiredDocuments() {

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        return WsService.getWithHeaders(ENDPOINT_BASE, {}, 200, registrationHeaders).then(
            response => {
                let results = [];
                response.forEach(jsonDocuments => {
                        results.push(new RegistrationRequiredDocument(jsonDocuments));
                    }
                );
                return results;
            },
            response => {
                return response;
            });
    }

    static retrievePresignedUrl(s3RegistrationDocumentsUploadRequest) {

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let endpoint = ENDPOINT_BASE + "/generate-upload-url";

        return WsService.postWithHeaders(endpoint, s3RegistrationDocumentsUploadRequest, 200, registrationHeaders).then(
            response => {
                return new S3DocumentMetaDataWithUrl(response);
            },
            response => {
                return "Fail";
            });
    }

}